import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { currentInventory } from '../models/currentInventory';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ImageCompressService } from 'ng2-image-compress';

@Component({
  selector: 'app-current-inventory',
  templateUrl: './current-inventory.component.html',
  styleUrls: ['./current-inventory.component.css']
})
export class CurrentInventoryComponent implements OnInit {
  showFilter:boolean=false
  currentInventoryAddObj:currentInventory
  currentInventoryUpdateObj:currentInventory
  myurl:string
  show: boolean = false
  showTextField: boolean = false
  showSubTextField: boolean = false
  categoriesList:any
  dataSource: any;
  tableData: [] = [];
  userSessionData:any;
  userDetails:any;
  read:any;
  write:any;
  delete:any;
  subCategoriesList:any;
  vendorsList:any=[];
  userAccountsList:any
  displayedColumns = [ 'accountEmailId', 'productName','productUniqueNumber','productImage','description','stockQuantity','stockUnit','purchaseDate','expiryDate','storageLocation','borrowed','category','subCategory','price','orderId','vendorId','uploadType','status','productManuallyAddOrAutoMovedDate','addedByUserId','Actions']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("currentInventory") form: any;
  @ViewChild("currentInventoryUpdate", { static: true }) formUpdate: any;
  theDate: any;
  thePurchaseDate:any
  showCustomisedSearch:boolean=false;
  searchValue:any;
  filterValueSelected:any;
  export:any
  image = { 'URL': '', 'valid': false };
pic:any
currentDate=new Date()
  productImageId: any;
  constructor(private cs:CucurachaAdminService,private toastr: ToastrManager,private excelService: ExcelService) {
    this.currentInventoryAddObj=new currentInventory();
    this.currentInventoryUpdateObj=new currentInventory()
    this.myurl = this.cs.endpoint;

   }
   filter() {
    this.getAllCurrentInventory()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""


      this.form.reset();

    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""

      this.form.reset();



    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllCurrentInventory();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForCurrentInventory(this.filterValueSelected, filterValue).subscribe((data) => {
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllCurrentInventory()
    }
  }
  addCurrentInventory() {
    this.pic = ""
    if (this.show == false) {
      this.show = true
      this.formUpdate.reset()
      this.form.reset()

    }
    else {
      this.pic = ""

      this.show = false
      this.form.reset();
      this.formUpdate.reset()
      this.showSubTextField=false
      this.showTextField=false
    }
  }
  saveCurrentInventory(borrowed:any){
    this.currentInventoryAddObj.borrowed=borrowed.value
    this.currentInventoryAddObj.adminId=this.userDetails._id
    this.currentInventoryAddObj.adminEmailId=this.userDetails.emailId
    this.cs.saveCurrentInventory(this.currentInventoryAddObj).subscribe((data) => {
      if (data.result) {
        this.getAllCurrentInventory();
        this.toastr.successToastr(data.message);
        this.form.reset();
        this.pic="";


      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    })

  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  fileChangeEvent(fileInput: any) {
    ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
      observableImages.subscribe((image) => {
        this.image.URL = image.compressedImage.imageDataUrl;
        this.currentInventoryAddObj.productImage = image.compressedImage.imageDataUrl;
        this.currentInventoryAddObj.productImage = this.currentInventoryAddObj.productImage.replace("data:image/gif;base64,", "");
        this.currentInventoryAddObj.productImage = this.currentInventoryAddObj.productImage.replace("data:image/jpeg;base64,", "");
        this.currentInventoryAddObj.productImage = this.currentInventoryAddObj.productImage.replace("data:image/jpg;base64,", "");
        this.currentInventoryAddObj.productImage = this.currentInventoryAddObj.productImage.replace("data:image/png;base64,", "");
        this.pic = image.compressedImage.imageDataUrl
      }, (error) => {
        this.toastr.errorToastr("Error while converting");
      });
    });
  }
  fileChangeUpdateEvent(fileInput: any) {
    ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
      observableImages.subscribe((image) => {
        this.image.URL = image.compressedImage.imageDataUrl;
        this.currentInventoryUpdateObj.productImage = image.compressedImage.imageDataUrl;
        this.currentInventoryUpdateObj.productImage = this.currentInventoryUpdateObj.productImage.replace("data:image/gif;base64,", "");
        this.currentInventoryUpdateObj.productImage = this.currentInventoryUpdateObj.productImage.replace("data:image/jpeg;base64,", "");
        this.currentInventoryUpdateObj.productImage = this.currentInventoryUpdateObj.productImage.replace("data:image/jpg;base64,", "");
        this.currentInventoryUpdateObj.productImage = this.currentInventoryUpdateObj.productImage.replace("data:image/png;base64,", "");
        this.pic = image.compressedImage.imageDataUrl
      }, (error) => {
        this.toastr.errorToastr("Error while converting");
      });
    });
  }
  getAllCategories(){
    this.cs.getAllCategory().subscribe((data) => {
     this.categoriesList=data

    });
  }
  getSubCategoryByCategoryId(id:any){
    if(this.currentInventoryAddObj.category!="Others"){
    this.cs.getSubCategoryByCategoryId(id).subscribe((data) => {
      
  this.subCategoriesList=data
  if(this.subCategoriesList.length==0){
    this.currentInventoryAddObj.subCategory="Others";
    this.currentInventoryUpdateObj.subCategory="Others"

    this.showSubTextField=true

  }
  else{
    this.currentInventoryAddObj.subCategory=" ";
    this.currentInventoryUpdateObj.subCategory=" ";
    this.showSubTextField=false;

  }
  this.showTextField=false;
     
    });
    
  }
  if(this.currentInventoryAddObj.category=="Others"){
      this.showTextField=true
    
  }

  }
  viewImages(id:any){
    this.productImageId=id
  }
  checking(id:any){
    if(this.currentInventoryAddObj.subCategory=="Others"){
      this.showSubTextField=true

    }
    else{
      this.showSubTextField=false

    }
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    this.excelService.exportAsExcelFile(this.tableData, 'CurrentInventory');
    this.cs.exportLogAdd(this.userDetails.emailId,'CurrentInventory').subscribe((data) => {
    })
  }
 
  getAllCurrentInventory(){
    console.log("hloo")
    this.cs.getAllcurrentInventory().subscribe((data) => {
     console.log(data.result)
      this.dataSource = new MatTableDataSource(data.result)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })

  }
  
  getByVendorStatus(id:any){
    this.cs.getByVendorStatus(id).subscribe((data) => {
      console.log(data)
      this.vendorsList=data.result

    })
  }
  getAllUserAccountsByStatus() {
    this.cs.getAllAccountsByStatus().subscribe((data) => {
      this.userAccountsList = data
    })
  }
  getByCurrentInventoryId(id){
    this.cs.getByCurrentInventoryId(id).subscribe((data) => {
      this.cs.getSubCategoryByCategoryId( data[0].category).subscribe((data) => {
      
        this.subCategoriesList=data
      })
      this.currentInventoryUpdateObj._id = data[0]._id;
      this.currentInventoryUpdateObj.accountId = data[0].accountId;
      this.currentInventoryUpdateObj.productName = data[0].productName;
      this.currentInventoryUpdateObj.productUniqueNumber = data[0].productUniqueNumber;

      this.currentInventoryUpdateObj.description = data[0].description
      this.currentInventoryUpdateObj.accountId = data[0].accountId;

      this.currentInventoryUpdateObj.stockQuantity = data[0].stockQuantity;
      this.currentInventoryUpdateObj.stockUnit = data[0].stockUnit
      this.currentInventoryUpdateObj.purchaseDate = data[0].purchaseDate;
      this.thePurchaseDate=data[0].purchaseDate;

      this.currentInventoryUpdateObj.expiryDate = data[0].expiryDate;
       this.theDate=data[0].expiryDate;
      this.currentInventoryUpdateObj.storageLocation = data[0].storageLocation
      this.currentInventoryUpdateObj.borrowed = data[0].borrowed

      this.currentInventoryUpdateObj.category = data[0].category
       this.currentInventoryUpdateObj.subCategory = data[0].subCategory
      this.currentInventoryUpdateObj.orderId = data[0].orderId
      this.currentInventoryUpdateObj.vendorId = data[0].vendorId;
      this.currentInventoryUpdateObj.price=data[0].price;
      this.currentInventoryUpdateObj.productStatus=data[0].productStatus;
      this.currentInventoryUpdateObj.updatingQuantity=data[0].stockQuantity;

      this.pic = this.myurl + 'Misc/Images/productImages/' + data[0].productId+'_0'

      this.cs.getByVendorId( this.currentInventoryUpdateObj.vendorId).subscribe((data)=>{
        this.vendorsList=data
        console.log(this.vendorsList)
      })
      

    })
  }
  updateCurrentInventory(){
   
    this.currentInventoryUpdateObj.purchaseDate = this.thePurchaseDate;

    this.currentInventoryUpdateObj.expiryDate =this.theDate;
    this.currentInventoryUpdateObj.adminId=this.userDetails._id
    this.currentInventoryUpdateObj.adminEmailId=this.userDetails.emailId

    this.cs.updateCurrentInventory(this.currentInventoryUpdateObj).subscribe((data) => {
      this.getAllCurrentInventory()
      
        this.toastr.successToastr(data.message);

      
    })
  }
  updateCurrentInventoryProductStatus(){
console.log(this.userDetails)
    this.currentInventoryUpdateObj.expiryDate =this.theDate;
    this.currentInventoryUpdateObj.adminId=this.userDetails._id
    this.currentInventoryUpdateObj.adminEmailId=this.userDetails.emailId


    this.cs.updateCurrentInventoryProductStatus(this.currentInventoryUpdateObj).subscribe((data) => {
      this.getAllCurrentInventory();

        this.toastr.infoToastr(data.message);

      
    })
  }
  onChange(status, id) {
    this.cs.getByCurrentInventoryId(id).subscribe((data) => {
      this.currentInventoryAddObj._id = data[0]._id;
      this.currentInventoryAddObj.status = status.checked;

      this.cs.updateCurrentInventoryStatus(this.currentInventoryAddObj).subscribe((data) => {
        if(data.result ){
          this.ngOnInit()
          this.toastr.infoToastr(data.message);
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
          this.ngOnInit()
    
         }
          else{
            this.toastr.errorToastr(data.message);
            this.ngOnInit()

    
          }
      })
    })
  }
  deleteCurrentInventory(id:any){
    this.cs.deleteCurrentInventoryById(id).subscribe((data) => {
      if(data.result){
        this.toastr.infoToastr('Product Deleted')
        this.getAllCurrentInventory();

      }
      else
      this.toastr.errorToastr(data.message)
    })
  }
  ngOnInit(): void {
    console.log("hii")
    this.getAllCategories()
    this.getAllCurrentInventory();
    this.getAllUserAccountsByStatus()
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
 
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
      this.read = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].read);
      this.write = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].write)
      this.delete = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].delete)
      this.export = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].export)

    })
  }

}
